export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Sneakersy, buty sportowe i casual',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flat%20lay%20sneakers%20collection%20white%20air%20force%20dunk%20jordan%20on%20warm%20cream%20linen%20surface%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20high%20detail%20warm%20neutral%20tones&width=600&height=600&seq=cat-shoes-2026&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Bluzy, swetry i dzianiny',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stacked%20folded%20hoodies%20sweaters%20in%20neutral%20earth%20tones%20beige%20cream%20tan%20olive%20on%20wooden%20shelf%20soft%20natural%20light%20minimal%20editorial%20fashion%20photography%20warm%20aesthetic%20clean%20composition&width=600&height=600&seq=cat-hoodies-2026&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    description: 'Koszulki i topy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20cotton%20t-shirts%20in%20pastel%20and%20neutral%20colors%20on%20warm%20cream%20linen%20flat%20lay%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20tones&width=600&height=600&seq=cat-tshirts-2026&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-windy-line',
    description: 'Kurtki i płaszcze',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20and%20denim%20jacket%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20cream%20wall%20soft%20natural%20lighting%20editorial%20fashion%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=600&height=600&seq=cat-jackets-2026&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-cut-line',
    description: 'Spodnie i szorty',
    imageUrl: 'https://readdy.ai/api/search-image?query=Folded%20cargo%20pants%20and%20denim%20shorts%20on%20warm%20cream%20textured%20surface%20flat%20lay%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20earth%20tones&width=600&height=600&seq=cat-pants-2026&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-goblet-line',
    description: 'Czapki i kapelusze',
    imageUrl: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20and%20beanie%20beanies%20displayed%20on%20minimal%20cream%20pedestal%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones%20high%20detail&width=600&height=600&seq=cat-headwear-2026&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-layout-grid-line',
    description: 'Zestawy i komplety',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20hoodie%20and%20jogger%20set%20neatly%20folded%20on%20warm%20cream%20linen%20surface%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=600&height=600&seq=cat-sets-2026&orientation=squarish',
  },
  {
    name: 'Underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shape-line',
    description: 'Bielizna i slipy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20boxer%20briefs%20folded%20naturally%20on%20warm%20cream%20textured%20surface%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=600&height=600&seq=cat-underwear-2026&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Koszulki sportowe i trykoty',
    imageUrl: 'https://readdy.ai/api/search-image?query=Football%20soccer%20jersey%20laid%20flat%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20minimal%20editorial%20sports%20photography%20clean%20aesthetic%20warm%20neutral%20tones%20high%20detail&width=600&height=600&seq=cat-jersey-2026&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-keyboard-box-line',
    description: 'Dodatki i akcesoria',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20watch%20sunglasses%20wallet%20keychain%20arranged%20on%20warm%20cream%20marble%20surface%20flat%20lay%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=600&height=600&seq=cat-accessories-2026&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    description: 'Torby i plecaki',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20backpack%20and%20tote%20bag%20displayed%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones%20high%20detail&width=600&height=600&seq=cat-bags-2026&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-loop-left-line',
    description: 'Paski i akcesoria',
    imageUrl: 'https://readdy.ai/api/search-image?query=Leather%20belts%20rolled%20and%20displayed%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones%20high%20detail&width=600&height=600&seq=cat-belts-2026&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Perfumy i zapachy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20cream%20marble%20surface%20with%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=600&height=600&seq=cat-perfumes-2026&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-apps-line',
    description: 'Pozostałe produkty',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20phone%20case%20wallet%20keychain%20notebook%20arranged%20on%20warm%20cream%20surface%20flat%20lay%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=600&height=600&seq=cat-other-2026&orientation=squarish',
  },
];